import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Feedback } from "./feedbacks.models";

@Injectable()

export class WebAppFeedbackService {
	// constructor
	constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

	// single
	single(id: string): Observable<Feedback> {
		return this.http.get<Feedback>(`${this.baseUrl}api/webapp/feedback/feedback/${id}`);
	}

	// insert
	insert(model): Observable<boolean> {
		return this.http.post<boolean>(`${this.baseUrl}api/webapp/feedback/feedback`, model);
	}
}